import { WELL_GUIDE_HEADER_NAVIGATION, VARIANT_ON } from './experiments';

export function sanitizeId(id) {
    if (id) {
        return id.replace(/_.*$/, '').replace('-', '');
    }
}

// TODO: refactor to remove this and above - use selectors instead
export const showWellGuideLink = ab => {
    return ab[WELL_GUIDE_HEADER_NAVIGATION.experimentId] === VARIANT_ON;
};
